import React from "react";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import { Box, Grid } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CancelIcon from "@mui/icons-material/Cancel";
import { styled, useTheme } from "@mui/material/styles";

//const drawerWidth = 800;
const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })<{
  open?: boolean;
}>(({ theme, open }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-start",
}));

export interface CommonProps {
  open: boolean;
  onClose?: () => void;
  onClick?: () => void;
  title: string;
  content: React.ReactNode;
  note?: any;
  subTitle?: any;
  icon?: any;
}

const RightDrawer: React.FC<CommonProps> = (props) => {
  const { open, onClose, title, content } = props;
  const theme = useTheme();

  return (
    <div className="right-drawer">
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <Main open={open}>
          <DrawerHeader />
        </Main>
        <Drawer
          className="right-drawer-large"
          sx={{
            flexShrink: 0,
            "& .MuiDrawer-paper": {},
            zIndex: 1202,
          }}
          variant="temporary"
          anchor="right"
          open={open}
        >
          <Box>
            {/* <Grid item xs={12} sm={12} lg={6}> */}
            <Grid>
              <div className="flex space-between border-down margin-down-10 large-drawer-title large-drawer-title-width">
                <div className="margin-down-5">
                  <div className="side-bar-title flex-gap">
                    <div>{title}</div>
                    <div className="center">{props.icon}</div>
                  </div>
                  {props.subTitle ? (
                    <div className="margin-up-10">
                      <span className="small-f note-side-drawer margin-right-10">
                        {" "}
                        {props.note}
                      </span>
                      <span className="small-f">: {props.subTitle}</span>
                    </div>
                  ) : (
                    ""
                  )}
                  <span></span>
                </div>
                <div className="center cancel-icon">
                  <IconButton onClick={onClose}>
                    {theme.direction === "rtl" ? (
                      <CancelIcon />
                    ) : (
                      <CancelIcon />
                    )}
                  </IconButton>
                </div>
              </div>

              <Divider />
              <div className="single-drawer-content">{content}</div>
            </Grid>
          </Box>
        </Drawer>
      </Box>
    </div>
  );
};
export default RightDrawer;
